<div class="language-switcher">
  <div ngbDropdown class="nav-item dropdown-user">
    <a
      class="nav-link dropdown-toggle dropdown-user-link"
      ngbDropdownToggle
      id="navbarLanguageDropdown"
      aria-haspopup="true"
      role="button"
      aria-expanded="false"
      aria-controls="languageMenu"
    >
      {{ selectedLanguage }}
    </a>
    <div
      id="languageMenu"
      ngbDropdownMenu
      aria-labelledby="navbarLanguageDropdown"
      class="dropdown-menu dropdown-menu-right"
      role="menu"
    >
      <div ngbDropdownItem (click)="setLanguage('ro')" role="menuitem">ro</div>
      <div ngbDropdownItem (click)="setLanguage('en')"  role="menuitem">en</div>
    </div>
  </div>
</div>
